import React, { useEffect, useState } from "react";
import flower from "../../../assets/icons/purpleFlower.webp";
import CommonTitle from "../../../components/CommonTitle";
import Card from "../../../components/block_turn/Card";
import { useParams } from "react-router-dom";
import {
  getBSDatesByBlockIdByDate,
  getSeasonByDate,
} from "../../../services/seasons";
import LoadingPage from "../../../components/LoadingPage";
import { getSupplies } from "../../../services/medicines";
import { IS_LOCAL_ENV } from "../../../App";

const times = {
  A: "4 am a 5:59 am",
  B: "6 am a 11:59 am",
  C: "12 pm a 5:59 pm",
  D: "6 pm a 8:30 pm",
};

const BlockTurn = () => {
  const { blockLetter } = useParams();
  const [loading, setLoading] = useState(true);
  const [currentDate, setCurrentDate] = useState();
  const [currentSeason, setCurrentSeason] = useState({});
  const [scheduledDates, setScheduledDates] = useState([]);
  const [supplies, setSupplies] = useState([]);
  //const []
  //const [currentDate, setCurrentDate] = useState(new Date());
  //================Fetch current season by current date=====================
  useEffect(() => {
    const fetchData = async () => {
      try {
        let strDate = new Date(Date.now()).toLocaleDateString("en-US", {
          timeZone: "America/Lima",
        }); //FECHA PERU EN FORMATO MES/DIA/AñO (formato necesario para compararlo con fechas de mongo)
        let currentDate_ = new Date(strDate);
        currentDate_.setHours(currentDate_.getHours() + 5);
        let tis = currentDate_.toISOString();

        IS_LOCAL_ENV && console.log("currentDate hoy: ", strDate);
        //let currentDate = "2024-11-12";
        setCurrentDate(strDate);
        //obtener temporada actual
        const response = await getSeasonByDate(tis);
        IS_LOCAL_ENV && console.log("data del back: ", response);
        setCurrentSeason(response.docs[0]);
        const blockObj = response.docs[0].blocks.filter(
          (block) => block.letter === blockLetter
        )[0];
        //obtener fechas programadas de un bloque específico a partir de una fecha
        const response2 = await getBSDatesByBlockIdByDate(blockObj.id, strDate);
        setScheduledDates(response2.docs);
        const response3 = await getSupplies();
        //obtener lista de medicinas
        setSupplies(response3.docs);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        IS_LOCAL_ENV && console.error(err);
      }
    };
    fetchData();
  }, []);

  //===========update obj==============
  const updateObj = (obj) => {
    let temp = [...scheduledDates];
    temp[0] = obj;
    setScheduledDates(temp);
  };

  const updateSupplies = (updatedSupplies) => {
    let temp = [...supplies]; // Copiamos los supplies actuales

    // Iteramos sobre los supplies actualizados
    updatedSupplies.forEach((updatedSupply) => {
      temp = temp.map((supply) => {
        // Si el ID coincide, actualizamos la cantidad
        if (supply.id === updatedSupply.id) {
          return { ...supply, quantity: updatedSupply.quantity };
        }
        // Si no coincide, devolvemos el supply original
        return supply;
      });
    });

    // Actualizamos el estado con los supplies modificados
    setSupplies(temp);
  };

  return (
    <div className="w-full h-full flex flex-col">
      <CommonTitle
        img={flower}
        title={`Registro del bloque ${blockLetter}`}
        text={
          times[blockLetter]
            ? `El procedimiento se toma entre las ${times[blockLetter]}`
            : "Bloque adicional. Consulta el horario con el admin"
        }
      >
        <div className=" flex flex-row items-center bg-light-purple rounded-full font-poppins px-6 py-4 text-dark-purple ">
          <h2 className="font-poppins text-lg text-default-gray">
            {currentSeason.name ? currentSeason.name : "..."}
          </h2>
        </div>
      </CommonTitle>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="w-full flex justify-center">
          <div className="flex flex-wrap max-w-[1280px] w-full justify-center md:p-6 p-2">
            {scheduledDates.map((sDate, i) => {
              return (
                <Card
                  sDateInfo={sDate}
                  pos={i}
                  key={i}
                  seasonNumber={currentSeason.number}
                  currentDate={currentDate}
                  updateParentObj={updateObj}
                  supplies={supplies}
                  updateParentSupplies={updateSupplies}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default BlockTurn;
